import script from "./CheckInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckInfo.vue?vue&type=script&setup=true&lang=js"

import "./CheckInfo.vue?vue&type=style&index=0&id=52916d3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52916d3d"]])

export default __exports__